<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2L9Po6/tc-custom/9781488039867.jpg?1706988703543" alt="This image is the cover for the book Trusting Her Heart, Meet Me at the Altar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trusting Her Heart, Meet Me at the Altar
      </h1>
      <p class="bookDescription body article font2">
        <b>Can a love built on lies…</b><br/><br/>…survive the truth?<br/><br/>Serena Stanhope fears her dark past might ruin the life she’s built as a successful shop owner. Especially when handsome Logan Masterson suddenly arrives in town asking questions about her background. He seems to have his own secrets, but the pair share an instant connection and Serena finds herself falling for Logan. He could destroy everything—or he could be the chance at love she thought she’d never have…
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tara Randel
      </h2>
      
      <p class="authorDescription body article">Tara Randel is an award-winning, USA Today bestselling author. Family values, a hint of mystery, and, of course, love, are her favorite themes because she believes&#160;love is the greatest gift of all. Visit Tara at www.tararandel.com or like her Facebook page, Tara Randel Books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8c2ed6fe